import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Trends = () => {
  return (
    <EmptyPage
      title="Market Trends"
      description="Discover market trends, price movements, and forecasting insights to make informed investment decisions and strategic planning."
      icon="📉"
    />
  );
};

export default Trends;
